import React from "react";
import { MixWrapperStyled } from "./MixWrapperStyled";
import { MixWrapperProps } from "../../../entities/Mix";
import MixCard from "../MixCard";
import Typography from "../../../UI/Typography/Typography";
import { TYPOGRAPHY_TYPE } from "../../../entities/Typography";
import { VIEW_TYPE } from "../../../entities/Filter";
import { TEST_ID } from "../../../shared/testid";
import { useSelector } from "react-redux";
import { getAsideData } from "../../Aside/slice/selectors";
import { useLocation } from "react-router-dom";

const MixWrapper: React.FC<MixWrapperProps> = ({
  title,
  mixes = [],
  view = VIEW_TYPE.GRID,
}: MixWrapperProps) => {
  const { asideCategories } = useSelector(getAsideData);
  const location = useLocation();

  const activeAsideItem = asideCategories.find(
    (item) => item.to === location.pathname,
  );

  return (
    <MixWrapperStyled>
      <div className="mix-wrapper__title">
        <Typography type={TYPOGRAPHY_TYPE.TITLE_FIVE}>{title}</Typography>
      </div>
      <div
        className={`mix-wrapper__items view-${view}`}
        data-length={mixes.length}
        data-testid={TEST_ID.MIXES.WRAPPER}
      >
        {mixes.filter((mix) => {
          if (activeAsideItem && activeAsideItem.id === 4) {
            const existCategory = mix?.categories?.length ? mix?.categories?.find(category => category?.id === activeAsideItem.id) : mix.categoryId === activeAsideItem.id;
            return existCategory ? mix : null;
          } else {
            return mix;
          }
        }).map((mix) => (
          <MixCard key={mix.id} mix={mix} view={view} />
        ))}
      </div>
    </MixWrapperStyled>
  );
};

export default MixWrapper;